import React from 'react'

/**
 * Shared React Context for passing the current repeater item down to descendants.
 *
 * Used by the template binding flow:
 *  - Producer: `useRenderProps` in `feature-react-renderer` wraps the template
 *    container's subtree with <TemplateItemContext.Provider value={{ item, index }}>.
 *  - Consumer: `ContextBindingWrapper` in `feature-builder-context-providers` calls
 *    `useContext(TemplateItemContext)` to resolve `TemplateBindingConfig` bindings.
 *
 * Lives in this shared package so both sides can reference the same context
 * identity without creating a cross-feature dependency.
 */
export type TemplateItemContextValue = {
	item: unknown
	index: number
} | null

export const TemplateItemContext = React.createContext<TemplateItemContextValue>(null)
